import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { itemPriceManagementRouter } from './routing/itemPriceManagementRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { itemPriceManagementAccessControl } from './access-control/itemPriceManagementAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'item-price-management',
  totem: {
    tool: 'item-price-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [itemPriceManagementRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Catalog,
      attachToV3: NavEntryPointV3.Catalog,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage item pricing rules, store assignments, and change requests',
          labelId: 'itemPriceManagementDomain.title',
          route: 'item-price-management-change-requests',
          subRoutes: [
            'item-price-management-rules',
            'item-price-management-rules-compare',
            'item-price-management-active-rules',
            'item-price-management-change-request-create',
            'item-price-management-change-request-detail',
            'item-price-management-change-request-edit',
            'item-price-management-change-request-review',
            'item-price-management-product-list-edit',
            'item-price-management-product-list-detail',
          ],
          accessControl: itemPriceManagementAccessControl,
          positionNavV2: 11,
          positionNavV3: 11,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
